import { render, staticRenderFns } from "./assignMC.vue?vue&type=template&id=8800c112"
import script from "./assignMC.vue?vue&type=script&lang=js"
export * from "./assignMC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports